<template>
  <div class="mod-enterprise site-wrapper">
    <div class="btn-control">
      <div class="tabs">
        <button v-for="tab of tabs" v-bind:class="['tab_button', { active: currentTab === tab.code }]"
          @click="tabChangeHdandle(tab.code)" :key="tab.code"
          :disabled="!currentTab && tab.code != '' && !tableData.length">{{ tab.val }}</button>
      </div>
      <div class="add">
        <el-button v-if="tableData.length > 0" type="primary" size="mini" round @click="addOrUpdateHandle()">新增
        </el-button>
      </div>
    </div>
    <div class="lists">
      <div v-if="!listLoading && !tableData.length"
        style="width: 300px;margin: 0 auto;text-align: center;margin-top: 141px;">
        <img src="@/assets/img/noData.png" height="128" width="141" />
        <p v-if="noCompany" style="font-size: 24px;font-weight: bold;margin-bottom:38px;margin-top:16px;">哦豁！还没有关联企业。
        </p>
        <el-button v-if="noCompany" style="font-size: 16px;" type="primary" round @click="addOrUpdateHandle()">立即新增企业
        </el-button>
      </div>
      <el-table v-if="tableData.length > 0" :data="tableData" v-loading="listLoading" stripe border style="width: 100%">
        <el-table-column prop="name" label="企业名称"></el-table-column>
        <el-table-column prop="legalMan" label="法人" width="80"></el-table-column>
        <el-table-column prop="ratepayCode" label="纳税识别码"></el-table-column>
        <el-table-column prop="addr" label="企业地址" width="180"></el-table-column>
        <el-table-column label="营业执照" width="79">
          <template slot-scope="scope">
            <el-image style="height: 24px" :preview-src-list="[getUrl(scope.row.businessLicense)]"
              :src="getUrl(scope.row.businessLicense)">
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="stValue" label="状态" width="80">
          <template slot-scope="scope">
            <span :style="{ color: textColor(scope.row.st), 'font-weight': 'bold' }">{{ getStCn(scope.row.st) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="98" label="操作" align="center">
          <template slot-scope="scope">
            <span @click="addOrUpdateHandle(scope.row.relId)" class="text_btn primary_text">{{['DEPT_AUDIT_F','DEPT_AUDIT_DTJ'].includes(scope.row.st)?'编辑':"查看"}}</span>
            <span v-if="scope.row.st!='DEPT_AUDIT_DSH'" class="line">|</span>
            <span v-if="scope.row.st!='DEPT_AUDIT_DSH'" class="text_btn" style="color: #FF6F77;" @click="deleteHandle(scope.row.relId)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="tableData.length > 0" class="mod-page">
        <pagination v-show="totalPage > 0" :total="totalPage" :page.sync="pageIndex" :limit.sync="pageLimt"
          @pagination="getDataList" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { previewUrl } from "@/utils";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      noCompany: false,
      listLoading: false,
      tableData: [],
      tabs: [],
      pageIndex: 1,
      pageLimt: 10,
      totalPage: 0,
      currentTab: ''
    };
  },
  created() {
    this.getDWtype();
    this.getDataList();
  },
  methods: {
    getUrl(url){
			return previewUrl(url);
		},
    getStCn(st){
      return this.tabs.filter(v=>v.code == st)[0].val;
    },
    textColor(st) {
      switch (st) {
        case 'DEPT_AUDIT_F':
          return '#FF6F77';

        case 'DEPT_AUDIT_T':
          return '#36C626';

        default:
          return '#1460AE';
      }
    },
    tabChangeHdandle(tab) {
      this.currentTab = tab;
      this.getDataList();
    },
    getDataList() {
      this.listLoading = true;
      let params = {
        current: this.pageIndex,
        size: this.pageLimt,
        data: {
          st: this.currentTab,
          name: "",
          orgCode: "",
          legalMan: ""
        }
      };
      this.$http.post(this.$api.shiroApi.deptList, params).then(({ data }) => {
        this.listLoading = false;
        this.tableData = data.data.list;
        this.totalPage = data.data.total;
        if (!this.tableData.length && !this.currentTab) {
          this.noCompany = true;
        }
      }).catch(()=>{
        this.listLoading = false;
      });
    },
    getDWtype() {
      this.$http.get(this.$api.dicApi.getDic + '?code=DEPT_AUDIT').then(({ data }) => {
        this.tabs = [{
          code: "",
          val: "全部"
        }].concat(data.data);
      });
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.$router.push({ name: "enterprise-details", query: { id: id } });
    },
    // 删除
    deleteHandle(id) {
      this.$confirm("确定删除企业？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          relId: id
        };
        this.$http.post(this.$api.shiroApi.deleteDept, params).then(({ data }) => {
          if (data.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.getDataList();
              }
            });
            return
          }
          this.$message.error(data.msg);
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.mod-enterprise {
  .btn-control {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .add {
      button {
        padding: 8px 21px;
        font-size: 14px;
      }
    }
  }

  .lists {
    min-height: 613px;
    background: #fff;
    padding: 24px;
    box-shadow: 0px 2px 31px 1px rgb(0 0 0 / 3%);
    border-radius: 16px;
    margin-bottom: 32px;
  }
}

.tabs button:disabled {
  opacity: .7;
  cursor: no-drop;
}
</style>
